<button
  type="button"
  mat-stroked-button
  *ngIf="rsf && rsf.status == formStatusEnum.Draft"
  [disabled]="rsf.editingBy?.id !== currentUser?.id || disabled"
  class="mr-1 mt-2"
  (click)="editOlog()"
  color="primary"
>
  Edit Olog
</button>
